import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DOCTOR_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchData1 = (data: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: data,
});
export const fetchData2 = (pmh: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: pmh,
});
export const fetchData3 = (currentmedication: any) => ({
    type: 'FETCH_DATA3_SUCCESS',
    payload: currentmedication,
});
export const fetchData4 = (ros: any) => ({
    type: 'FETCH_DATA4_SUCCESS',
    payload: ros,
});
export const fetchData5 = (complaint: any) => ({
    type: 'FETCH_DATA5_SUCCESS',
    payload: complaint,
});
export const fetchData6 = (exam: any) => ({
    type: 'FETCH_DATA6_SUCCESS',
    payload: exam,
});
export const fetchData7 = (assisment: any) => ({
    type: 'FETCH_DATA7_SUCCESS',
    payload: assisment,
});
export const DiagnosisData = (diag: any) => ({
    type: 'FETCH_DATA8_SUCCESS',
    payload: diag,
});



export const fetchNoteData = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,caseid:id};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchPmh = (type:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,caseid:id,type:'pmh'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchCurrentMedication = (type:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,caseid:id,type:'currentmedication'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchros = (type:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,caseid:id,type:'ros'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData4(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchComplaint = (type:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,caseid:id,type:'complaint'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData5(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchExam = (type:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,caseid:id,type:'exam'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData6(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAssisment = (type:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,caseid:id,type:'assesment'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData7(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const Diagnosis = (type:any,diagnosisName:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:7,name:diagnosisName,type:'icd10'};
            const apiname = DOCTOR_API.notes_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(DiagnosisData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
